/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Text/Text';
import './CenteredText.scss';

/**
 * This is the CenteredText component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function CenteredText({ text, dropcap }) {
  return (
    <div className="block centered-text">
      <Text dropcap={dropcap}>{text}</Text>
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
CenteredText.propTypes = {
  dropcap: PropTypes.bool,
  text: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
CenteredText.defaultProps = {
  dropcap: false,
  text: '',
};

export default CenteredText;
